export const VALUE_TYPES_CONTENT_DISABLED = ["date", "before_date", "location"];

export const VALUE_TYPES_IMPORT_DISABLED = ["location"];
